import React from "react";

import styles from "./Divider.module.scss";

interface Props {
  type: "horizontal" | "vertical";
}

export const Divider = ({ type }: Props) => (
  <div className={`${styles.divider} ${type === "vertical" ? styles.dividerVertical : ""}`} />
);
